import React from 'react'

const About = () => {
  return (
    <div>
      <h1>About</h1>
      <p>This is an iNotebook app.</p>
    </div>
  )
}

export default About
